import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import TermsAndConditions from './pages/TermsAndConditions';
import TermsDeclined from './pages/TermsDeclined';
import TooYoung from './pages/TooYoung';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/terms" element={<TermsAndConditions standalone />} />
          <Route path="/terms-declined" element={<TermsDeclined />} />
          <Route path="/too-young" element={<TooYoung />} />
          <Route path="*" element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
